import styled from "styled-components";
import { COLORS } from "../../../layout/theme";

export const Inner = styled.div`
	padding: 30px 20px;
	background-color: ${COLORS.LightGrey};
	min-height: 65vh;

	@media only screen and (min-width: 600px) and (max-width: 860px) {
	}
`;

export const Section = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;
